import { createContext, useContext } from 'react';

export interface LogData {
  screenName?: string;
  pageCategory?: string;
  params?: Record<string, unknown>;
}

const LogDataContext = createContext<LogData | undefined>(undefined);

export function useLogData() {
  return useContext(LogDataContext);
}

export default LogDataContext;
